import variables from '@/assets/scss/_variables.scss'

export let state = {
    ...variables
}
